/* eslint-disable no-unused-vars */

export enum FEATURE_TYPE {
  FEATURE = "features",
  INFO = "info",
  LABEL = "label",
}

export enum LOCK_STATUS {
  CLOSE = "CLOSED",
  OPEN = "OPEN",
}

export const weekDays = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
];
